import React from "react";
import ActivityLogFilters from "./components/activityLogFilters";
import ActivityLogTable from "./components/ActivityLogTable";
import PageTitle from "../../components/Page/PageTitle";
import PageWrapper from "../../components/Page/PageWrapper";
import { useTranslation } from "react-i18next";

const ActivityLog = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.activityLog")} />
      <ActivityLogFilters />
      <ActivityLogTable />
    </PageWrapper>
  );
};

export default ActivityLog;
